import { createActions, createReducer } from 'reduxsauce'
import _ from 'lodash'
import Immutable from 'seamless-immutable'

export const INITIAL_STATE = Immutable({
  liveTracking: null,
  driverMapVisibility: false,

  driverLoaded: false,
  driverLoading: false,

  driverAdding: false,
  drivers: {},

  analyticOrders: {},
  analyticDriverActivities: {},
  analyticLoading: false,

  timeSlot: {},
  readyToPickUp: false,
  readyToPickUpLoaded: false,

  nonVerifyTransactions: {},
  gettingNonVerifyTransactions: false,
})

const { Types, Creators } = createActions({
  syncDrivers: null,
  setDrivers: ['drivers'],
  setDriver: ['driverUID', 'data'],

  setDriversLoading: ['val'],
  setDriversAdding: ['val'],

  saveDriver: ['driverUID', 'data', 'callBack'],
  deleteDriver: ['driverUID'],
  toggleDriverOnline: ['driver'],

  setAnalyticLoading: ['val'],
  setAnalyticOrders: ['data'],
  setAnalyticDriverActivities: ['data'],
  getAnalyticOrders: ['startAt', 'endAt'],

  fetchTimeSlot: null,
  updateTimeSlot: ['data'],
  setTimeSlot: ['data'],
  setReadyToPickUp: ['val'],
  setReadyToPickUpLoaded: ['val'],

  getNonVerifyTransactions: null,
  setNonVerifyTransaction: ['data'],
  setNonVerifyTransactions: ['data'],
})

export const setDriversReducer = (state, { drivers }) =>
  state.set('drivers', drivers).set('driverLoaded', true)

export const setDriverReducer = (state, { driverUID, data }) =>
  state.setIn(
    ['drivers', driverUID],
    state.drivers[driverUID] ? { ...state.drivers[driverUID], ...data } : data
  )

export const setDriversLoadingReducer = (state, { val }) => state.set('driverLoading', val)

export const setDriversAddingReducer = (state, { val }) => state.set('driverAdding', val)

export const deleteDriverReducer = (state, { driverUID }) =>
  state.set('drivers', _.omit(state.drivers, driverUID))

export const setAnalyticOrdersReducer = (state, { data }) => state.set('analyticOrders', data)

export const setAnalyticDriverActivitiesReducer = (state, { data }) =>
  state.set('analyticDriverActivities', data)

export const setAnalyticLoadingReducer = (state, { val }) => state.set('analyticLoading', val)

export const setTimeSlotReducer = (state, { data }) => state.set('timeSlot', Object.assign({}, data))

export const setReadyToPickUpReducer = (state, { val }) => state.set('readyToPickUp', val)

export const setReadyToPickUpLoadedReducer = (state, { val }) => state.set('readyToPickUpLoaded', val)

export const getNonVerifyTransactionsReducer = state => state.set('gettingNonVerifyTransactions', true)

export const setNonVerifyTransactionsReducer = (state, { data }) =>
  state.set('gettingNonVerifyTransactions', false).set('nonVerifyTransactions', data)

export const setNonVerifyTransactionReducer = (state, { data }) => state.setIn(['nonVerifyTransactions', data.id], data)

export const driverReducer = createReducer(INITIAL_STATE, {
  [Types.SET_DRIVERS]: setDriversReducer,
  [Types.SET_DRIVER]: setDriverReducer,
  [Types.SET_DRIVERS_LOADING]: setDriversLoadingReducer,
  [Types.SET_DRIVERS_ADDING]: setDriversAddingReducer,

  [Types.SET_ANALYTIC_ORDERS]: setAnalyticOrdersReducer,
  [Types.SET_ANALYTIC_DRIVER_ACTIVITIES]: setAnalyticDriverActivitiesReducer,
  [Types.SET_ANALYTIC_LOADING]: setAnalyticLoadingReducer,

  [Types.DELETE_DRIVER]: deleteDriverReducer,

  [Types.SET_TIME_SLOT]: setTimeSlotReducer,
  [Types.SET_READY_TO_PICK_UP]: setReadyToPickUpReducer,
  [Types.SET_READY_TO_PICK_UP_LOADED]: setReadyToPickUpLoadedReducer,

  [Types.SET_NON_VERIFY_TRANSACTION]: setNonVerifyTransactionReducer,
  [Types.GET_NON_VERIFY_TRANSACTIONS]: getNonVerifyTransactionsReducer,
  [Types.SET_NON_VERIFY_TRANSACTIONS]: setNonVerifyTransactionsReducer,
})

export const DriverTypes = Types
export default Creators



// WEBPACK FOOTER //
// ./src/reducers/driverReducer.js